<div class="basic-details">
    <form class="row g-3" *ngIf="data?.tabName !== 'Attachments'" [formGroup]="data.formGroup">
        <ng-container *ngFor="let field of data.formFields">
            <div [ngClass] = "field.size" *ngIf="field.UIVisible && (!field.hasCondition)">
                <label *ngIf="((field.fieldName == 'cost_center' && showCostCenterField) || (field.fieldName !== 'cost_center')) && ((field.fieldName == 'wbs_element' && showWbsElementField)|| (field.fieldName !== 'wbs_element')) " [attr.for]="field?.displayName" class="form-label text-small">{{field?.displayName}} 
                    <!-- <sup *ngIf="field?.validators">*</sup> -->
                    <sup style="color :red" *ngIf="field?.required">*</sup>
                </label>
                <ng-container  *ngIf="field.fieldType !== 'textarea' && field.fieldType !== 'select' && ((field.fieldName == 'cost_center' && showCostCenterField)|| field.fieldName !== 'cost_center') && ((field.fieldName == 'wbs_element' && showWbsElementField)|| field.fieldName !== 'wbs_element') ">
                    <input [attr.type]="field.fieldSubType" class="form-control form-control-sm" [attr.id]="field?.displayName" 
                    [error]="data.formGroup.get(field.fieldName)"
                    [formControlName]="field.fieldName"
                    [attr.placeholder]="field?.displayName">
                </ng-container>
                <!-- [readonly]="data?.lineItemStatus == 'APPROVED'" -->
                <ng-container *ngIf="field.fieldType === 'select' && field.selectFields && field.fieldName !=='gl_account'&& field.fieldName !=='acc_assignment_value'">
                    <select class="form-select form-select-sm" 
                        [attr.id]="field?.displayName" 
                        [error]="data.formGroup.get(field.fieldName)"
                        [formControlName]="field.fieldName" 
                        [disabled]="data?.lineItemStatus == 'APPROVED'"
                        [attr.placeholder]="field?.displayName">
                        <option disabled selected value="">Select</option>
                        <option [value]="option[field.selectFields.bindLabel]" 
                        *ngFor="let option of optionValue((field.selectFields?.apiAsync$ | async)?.data, field.fieldName, field.selectFields.bindLabel)">
                        {{option[field.selectFields.bindValue]}}
                        </option>
                    </select>
                </ng-container> 
                
                <ng-container *ngIf="field.fieldType === 'select' && field.selectFields && field.fieldName ==='gl_account'">
                    <ng-select *ngIf="gl_account_Options?.length" [items]="gl_account_Options" [attr.placeholder]="field?.displayName"
                        formControlName="gl_account" (change)="onDropDownValueChange($event, 'gl_account')">
                    </ng-select>
                <input [attr.type]="field.fieldSubType" *ngIf="!gl_account_Options?.length" class="form-control form-control-sm" [attr.id]="field?.displayName"
                    [error]="data.formGroup.get(field.fieldName)" [formControlName]="field.fieldName"  
                    [attr.placeholder]="field?.displayName">
                </ng-container>

                <ng-container *ngIf="field.fieldType === 'select' && field.selectFields && field.fieldName ==='acc_assignment_value'">
                    <ng-select *ngIf="account_assignment_value_Options?.length && showCostCenterDropDown" [items]="account_assignment_value_Options" [attr.placeholder]="field?.displayName"
                        formControlName="acc_assignment_value" (change)="onDropDownValueChange($event,'acc_assignment_value' )">
                    </ng-select>
                <input [attr.type]="field.fieldSubType" *ngIf="!account_assignment_value_Options?.length || !showCostCenterDropDown" class="form-control form-control-sm" [attr.id]="field?.displayName"
                    [error]="data.formGroup.get(field.fieldName)" [formControlName]="field.fieldName" 
                    [attr.placeholder]="field?.displayName"
                    (keydown)="onKeydown($event)"
                    >
                </ng-container>

                <ng-container  *ngIf="field.fieldType == 'textarea'">
                    <textarea rows="4" cols="50" class="form-control"[attr.type]="field.fieldSubType"
                    class="form-control form-control-sm"
                    [attr.id]="field?.displayName" 
                    [error]="data.formGroup.get(field.fieldName)"
                    [formControlName]="field.fieldName" 
                    [attr.placeholder]="field?.displayName"
                    [hidden]="!field?.UIVisible">
</textarea>
                </ng-container>

                <form-feedback [formGroup]="data.formGroup" [field]="field.fieldName"></form-feedback>
            </div>
            <div [ngClass] = "field.size" *ngIf="field.UIVisible && (field.hasCondition && field.condition === 'Standard' && data.formGroup.controls['item_category'].value === 'Standard')">
                <label [attr.for]="field?.displayName" class="form-label text-small">{{field?.displayName}} 
                    <!-- <sup *ngIf="field?.validators">*</sup> -->
                    <sup style="color :red" *ngIf="field?.required">*</sup>
                </label>
                
    
                <ng-container *ngIf="field.fieldType === 'select' && field.selectFields">
                    <select class="form-select form-select-sm" 
                        [attr.id]="field?.displayName" 
                        [error]="data.formGroup.get(field.fieldName)"
                        [formControlName]="field.fieldName" [disabled]="data?.lineItemStatus == 'APPROVED'"
                        [attr.placeholder]="field?.displayName">
                        <option disabled selected value="">Select</option>
                        <!-- <option  value="true">Yes</option>
                        <option  value="false">No</option> -->
                        <option [value]="option[field.selectFields.bindValue]" 
                        *ngFor="let option of  field.selectFields.dataFields">
                        {{option.key}}
                        </option>
                    </select>
                </ng-container>    
                <form-feedback [formGroup]="data.formGroup" [field]="field.fieldName"></form-feedback>
            </div>
            <div [ngClass] = "field.size" *ngIf="field.UIVisible && (field.hasCondition && data.formGroup.controls['item_category'].value === 'Service' && field.condition === 'Service')">
                <label [attr.for]="field?.displayName" class="form-label text-small">{{field?.displayName}} 
                    <!-- <sup *ngIf="field?.validators">*</sup> -->
                    <sup style="color :red" *ngIf="field?.required">*</sup>
                </label>
                
    
                <ng-container *ngIf="field.fieldType === 'select' && field.selectFields">
                    <select class="form-select form-select-sm" 
                        [attr.id]="field?.displayName" 
                        [error]="data.formGroup.get(field.fieldName)"
                        [formControlName]="field.fieldName" 
                        [disabled]="data?.lineItemStatus == 'APPROVED'"
                        [attr.placeholder]="field?.displayName">
                        <option disabled selected value="">Select</option>
                        <option [value]="option[field.selectFields.bindLabel]" 
                        *ngFor="let option of optionValue((field.selectFields?.apiAsync$ | async)?.data, field.fieldName, field.selectFields.bindLabel)">
                        {{option[field.selectFields.bindValue]}}
                        </option>
                    </select>
                </ng-container>    
                <form-feedback [formGroup]="data.formGroup" [field]="field.fieldName"></form-feedback>
            </div>
            <ng-container *ngIf="acc_assignment_category == 'P-Project'">
                <div class="w-100 flexBox" *ngIf="field.fieldName === 'acc_assignment_value' && data?.formGroup?.get('WBS_Budget_Total_Value')?.value">
                    <span class="mx-2" style="font-weight: 600;">WBS Allocated Budget Value:
                    <span style="font-weight: normal;">{{ data?.formGroup?.get('WBS_Budget_Total_Value')?.value || "" }}</span>
                </span> 
                    <span class="mx-2" style="font-weight: 600;">WBS PO Utilized Value: 
                    <span style="font-weight: normal;">{{ data?.formGroup?.get('WBS_Utilized_Value')?.value || "" }}</span>
                </span>
                    <span class="mx-2" style="font-weight: 600;">WBS Balance Available: 
                    <span style="font-weight: normal;">{{ data?.formGroup?.get('WBS_Balance_Value')?.value || "" }}</span>
                </span>
                    <span class="mx-2" style="font-weight: 600;">Latest PO Number: 
                    <span style="font-weight: normal;">{{ data?.formGroup?.get('Latest_PO_Number')?.value || "" }}</span>
                </span>
                <span class="mx-2" style="font-weight: 600;">FY Year: 
                    <span style="font-weight: normal;">{{ data?.formGroup?.get('FY_YEAR')?.value || "" }}</span>
                </span>
                </div>
            </ng-container>
        </ng-container>
        
    </form>
    <!-- <div class="card mt-1" *ngIf="data?.tabName == 'Attachments'">
        <div class="card-body p-4">
            <div class="d-flex mb-4 mt-1"> -->
                <div class="file-upload" *ngIf="data?.tabName == 'Attachments'">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-sm-12 col-md-12 pt-5 position-relative">
                            <div class="upload-container">
                                <div class="upload-icon mx-3">
                                    <span class="fa fa-cloud-upload fa-5x"></span>
                                </div>
                                <div class="upload-title mx-3">
                                    <p>
                                        Drag and drop the file to upload
                                    </p>
                                </div>
                                <input type="file" #inputFile id="choose" (change)="verifyFile($event)" />
                            </div>
                            <div class="text-center my-3">
                                <a class="btn btn-outline-primary btn-lg" (click)="inputFile.click()">
                                    Choose File
                                </a>
                            </div>
                            <!-- <div class="text-center my-3">
                                <input class="form-control form-control-sm" type="text" id="upload_remarks" placeholder="Enter Remarks" [(ngModel)]="upload_remarks">
                            </div> -->
                            <div class="upload-instructions my-5 text-start">
                                <h6>Upload Instructions: </h6>
                                <ul>
                                    <li class='font-small'>
                                        1. During file upload, total size of the file must not exceed 20MB
                                    </li>
                                    <li class='font-small'>
                                        2. Only one file can be uploaded at a time
                                    </li>
                                </ul>
                            </div>
                            <!-- <div class="divider"></div> -->
                        </div>
                        <div class="col-xl-6 col-lg-6 col-sm-12 col-md-12 pt-5">
                            <div class="px-4 py-1">
                                <div class="text-start">
                                    <h6 class="fs-6">File Status</h6>
                                    <p class="text-muted my-3">
                                        Please select file to be uploaded.
                                    </p>
                                    <p className="text-muted my-3" *ngIf="data.prFiles?.length">
                                        File to be uploaded ({{data.prFiles?.length}} file).
                                    </p>
                                </div>
                                <ng-container *ngIf="data.prFiles?.length">
                                    <div class="my-4 upload-view" *ngFor="let f of data.prFiles;let i=index;">
                                        <div>
                                            <p class='mb-1'>
                                                {{f?.name ? f.name : f?.file?.name}}
                                            </p>
                                            <p class="mb-0 font-small">
                                                {{f?.formatSize ? f.formatSize:''}}
                                            </p>
                                        </div>
                                        <div class='align-self-center'>
                                            <a class='text-primary pointer' (click)="clearFile(i)">
                                                <span class="fa fa-trash fa-2x"></span>
                                            </a>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            <!-- </div>
        </div>
    </div> -->
</div>

<!-- && ((data.tabName && data.tabName == 'Account Details') && !data.isMRPPr)
&& ((data.tabName && data.tabName == 'Account Details') && !data.isMRPPr)
&& ((data.tabName && data.tabName == 'Account Details') && !data.isMRPPr) -->